// Utils
import { isEmpty } from '../../../../../common/utils/immutableHelper';
import { getElementId, getElementType } from '../../../../../common/elements/utils/elementPropertyUtils';
import {
    cardOrDocumentHasContent,
    columnHasContent,
    imageHasContent,
    linkHasContent,
} from '../../../../../common/elements/utils/elementTrashUtils';

// Constants
import { TASK_LIST_TYPE } from '../../../../../common/taskLists/taskListConstants';
import { COLUMN_TYPE } from '../../../../../common/columns/columnConstants';
import { COMMENT_THREAD_TYPE } from '../../../../../common/comments/commentConstants';
import { CARD_TYPE } from '../../../../../common/cards/cardConstants';
import { BOARD_TYPE } from '../../../../../common/boards/boardConstants';
import { ALIAS_TYPE } from '../../../../../common/alias/aliasConstants';
import { TASK_TYPE } from '../../../../../common/tasks/tasksConstants';
import { LINE_TYPE } from '../../../../../common/lines/lineConstants';
import { FILE_TYPE } from '../../../../../common/files/fileConstants';
import { IMAGE_TYPE } from '../../../../../common/images/imageConstants';
import { LINK_TYPE } from '../../../../../common/links/linkConstants';
import { DOCUMENT_TYPE } from '../../../../../common/documents/documentConstants';

const commentThreadHasComments = ({ element, commentsByThreadId }) => {
    const elementId = getElementId(element);
    const commentIds = commentsByThreadId[elementId];
    return !isEmpty(commentIds);
};

const elementHasChildren = ({ element, elementGraph }) => {
    const elementId = getElementId(element);
    const childrenIds = elementGraph[elementId];
    return !isEmpty(childrenIds);
};

export const elementIsInterestingForTrash = ({ element, elementGraph, commentsByThreadId }) => {
    const elementType = getElementType(element);

    switch (elementType) {
        case DOCUMENT_TYPE:
        case CARD_TYPE:
            return cardOrDocumentHasContent(element);
        case IMAGE_TYPE:
            return imageHasContent(element);
        case LINK_TYPE:
            return linkHasContent(element);
        case TASK_LIST_TYPE:
            return elementHasChildren({ element, elementGraph });
        case COMMENT_THREAD_TYPE:
            return commentThreadHasComments({ element, commentsByThreadId });
        case COLUMN_TYPE:
            return columnHasContent(element) || elementHasChildren({ element, elementGraph });
        case BOARD_TYPE:
        case ALIAS_TYPE:
        case FILE_TYPE:
            return true;
        case TASK_TYPE:
        case LINE_TYPE:
            return false;
        default:
            return true;
    }
};
